import { pageTitle } from '@palaccount/config';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Navigate, useLocation } from 'react-router';

import { groupForPath } from '@/app/shell/nav';
import { Card, CardContent } from '@/components/ui/card';

/**
 * The placeholder landing page every menu group opens in Phase 3. The module
 * screens land here in later phases; until then the page states plainly that
 * it is coming — an empty state, distinguishable from a loading state
 * (GEN-158).
 */
export function GroupPage() {
  const { t } = useTranslation();
  const location = useLocation();
  const group = groupForPath(location.pathname);

  useEffect(() => {
    if (group) document.title = pageTitle(t(group.pageKey));
  }, [group, t]);

  // An unknown path lands on the default screen rather than a dead end.
  if (!group) return <Navigate to="/" replace />;

  return (
    <Card>
      <CardContent className="flex flex-col items-center gap-2 py-16 text-center">
        <p className="text-lg font-semibold">{t(group.pageKey)}</p>
        <p className="text-sm text-muted-foreground">
          {t('shell.comingSoon')} — {t('shell.comingSoonSub')}
        </p>
      </CardContent>
    </Card>
  );
}
